export default function StockBadge({ qty, size = 'sm' }) {
  // qty can be 0, negative, or positive
  const isUndefined = qty === null || qty === undefined;
  const q = Number(qty) || 0;

  if (isUndefined) return null;

  if (q <= 0) {
    return (
      <span className={`inline-flex items-center gap-1 font-semibold rounded-lg px-2 py-0.5 bg-red-50 text-red-600 border border-red-200 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 inline-block" />
        نفد
      </span>
    );
  }

  if (q <= 10) {
    return (
      <span className={`inline-flex items-center gap-1 font-semibold rounded-lg px-2 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
        متبقي: {q}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-lg px-2 py-0.5 bg-emerald-50 text-emerald-700 border border-emerald-200 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block" />
      متوفر: {Number(q).toLocaleString('ar-EG', { maximumFractionDigits: 0 })}
    </span>
  );
}